import {
  CheckCircleFilled,
  LockFilled,
  MinusCircleFilled
} from "@ant-design/icons";
import { Col, Row, Steps, Typography } from "antd";
import React from "react";
import { TTranslate } from "../../../core/service/locale/TranslationService";
import Link from "../../../core/ui/components/Link";
import { CaseDecisionStatus } from "../../common/Constants";

export interface Props {
  status: string;
  translate: TTranslate;
  onClick(): void;
}

const { Step } = Steps;

const renderIcon = (currentStep: number, statusOrderNumber: number) => {
  if (currentStep === statusOrderNumber) {
    return <CheckCircleFilled className={"png-steps-title-active-icon"} />;
  }
  if (statusOrderNumber === currentStep + 10) {
    return <MinusCircleFilled className={"png-steps-title-wait-icon"} />;
  }

  return undefined;
};

const getCurrentStep = (status: string) => {
  switch (status) {
    case CaseDecisionStatus.IN_PROGRESS:
      return 0;
    case CaseDecisionStatus.RECORDED:
      return 1;
    case CaseDecisionStatus.VERIFIED:
      return 2;
    case CaseDecisionStatus.PUBLISHED:
      return 3;
    default:
      return 0;
  }
};

const CaseDecisionStatusSteps = ({ status, translate, onClick }: Props) => {
  const currentStep = getCurrentStep(status);
  switch (status) {
    case CaseDecisionStatus.ARCHIVED:
      return (
        <Steps size="small" current={currentStep} className={"png-steps"}>
          <Step
            title={translate(
              "editors.case_law_documents.status_values.ARCHIVED"
            )}
            className={"png-steps-title"}
            icon={<LockFilled />}
          />
        </Steps>
      );
    case CaseDecisionStatus.INVALIDATED:
      return (
        <Row style={{ display: "flex" }}>
          <Col>
            {" "}
            <Steps
              // style={{ width: "20%" }}
              size="small"
              current={currentStep}
              className={"png-steps"}
            >
              <Step
                title={translate(
                  "editors.case_law_documents.status_values.INVALIDATED"
                )}
                className={"png-steps-title"}
                icon={<LockFilled />}
              />
            </Steps>
          </Col>
          <Col>
            <Link
              block
              type="text"
              onClick={onClick}
              children={
                <Col>
                  <Typography.Paragraph ellipsis={{ rows: 3 }} strong>
                    {`Pogledajte stav sudske prakse kojim je invalidiran ovaj stav`}
                  </Typography.Paragraph>
                </Col>
              }
            />
          </Col>
        </Row>
      );
    default:
      return (
        <Steps size="small" current={currentStep} className={"png-steps"}>
          <Step
            title={translate(
              "editors.case_law_documents.status_values.IN_PROGRESS"
            )}
            className={"png-steps-title"}
            icon={renderIcon(currentStep, 0)}
          />
          <Step
            title={translate(
              "editors.case_law_documents.status_values.RECORDED"
            )}
            className={"png-steps-title"}
            icon={renderIcon(currentStep, 1)}
          />
          <Step
            title={translate(
              "editors.case_law_documents.status_values.VERIFIED"
            )}
            className={"png-steps-title"}
            icon={renderIcon(currentStep, 2)}
          />
          <Step
            title={translate(
              "editors.case_law_documents.status_values.PUBLISHED"
            )}
            className={"png-steps-title"}
            icon={renderIcon(currentStep, 3)}
          />
        </Steps>
      );
  }
};
export default CaseDecisionStatusSteps;
